import linkToAdminPages from "../links";

export default function linkToBetaControl() {
  return `${linkToAdminPages()}/beta-control`;
}
